import { z } from 'zod';
import { MoneyStr } from './common.js';

// ─── TRON-кошельки: опрос USDT-балансов через TronScan ──────────────────────

/** Base58-адрес TRON (mainnet, всегда начинается с T, 34 символа). */
export const TronAddress = z.string().regex(/^T[1-9A-HJ-NP-Za-km-z]{33}$/);
export type TronAddress = z.infer<typeof TronAddress>;

/** Конфиг для UI — БЕЗ ключа, только флаг keySet. */
export const TronConfigDto = z.object({
  enabled: z.boolean(),
  keySet: z.boolean(),
  updatedAt: z.string().nullable(),
});
export type TronConfigDto = z.infer<typeof TronConfigDto>;

/** apiKey: строка → перешифровать; null → очистить; отсутствует → не менять. */
export const UpdateTronConfigInput = z.object({
  enabled: z.boolean().optional(),
  apiKey: z.string().min(1).nullish(),
});
export type UpdateTronConfigInput = z.infer<typeof UpdateTronConfigInput>;

/** Кошелёк + последний закэшированный баланс (null — ещё не опрашивался). */
export const TronWalletRow = z.object({
  address: TronAddress,
  label: z.string(),
  enabled: z.boolean(),
  amount: MoneyStr.nullable(),
  fetchedAt: z.string().nullable(),
  error: z.string().nullable(),
});
export type TronWalletRow = z.infer<typeof TronWalletRow>;

export const CreateTronWalletInput = z.object({
  address: TronAddress,
  label: z.string().min(1).max(120),
});
export type CreateTronWalletInput = z.infer<typeof CreateTronWalletInput>;

export const UpdateTronWalletInput = z.object({
  label: z.string().min(1).max(120).optional(),
  enabled: z.boolean().optional(),
});
export type UpdateTronWalletInput = z.infer<typeof UpdateTronWalletInput>;

export const TronRefreshResult = z.object({
  ok: z.number().int(),
  failed: z.number().int(),
});
export type TronRefreshResult = z.infer<typeof TronRefreshResult>;
